import React from "react"
import PropTypes from "prop-types"

// components
import { Cell } from "fixed-data-table-2"

// helpers
import { createTableDisplayText } from "app/static/frontend/duplicate-management/helpers"

// datum cell for PotentialDuplicate resource table
const PotentialDuplicateDatumCell = props => (
    <Cell {...props}>
        { createTableDisplayText(props.datum.toJS()) }
    </Cell>
)

PotentialDuplicateDatumCell.propTypes = {
    datum: PropTypes.object.isRequired
}

export default PotentialDuplicateDatumCell
